<template>
  <div class="subsystemTableCom">
    <el-table
      :data="tableList"
      height="85%"
      stripe
      style="width: 100%"
      :header-cell-style="{
        'font-weight': 'bold',
        color: '#333',
        'background-color': '#F7F7F7',
      }"
    >
      <el-table-column
        v-for="(v, i) in tableHead"
        :key="i"
        :prop="v.prop"
        :label="v.label"
        align="center"
      ></el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        width="80"
        align="center"
        v-if="isOperation"
      >
        <template slot-scope="scope">
          <el-switch
            :value="scope.row.isOpen"
            @change="changeSwitch(scope.row)"
          ></el-switch>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="$parent.handleSizeChange"
      @current-change="$parent.handleCurrentChange"
      :current-page="$parent.currentPage"
      :page-sizes="[10, 30, 50]"
      :page-size="$parent.page.size"
      layout="total, sizes, prev, pager, next, jumper"
      :total="$parent.page.total"
      style="text-align: right; margin-top: 10px"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  props: ["tableHead", "tableList", "isOperation"],
  data() {
    return {};
  },
  methods: {
    changeSwitch(row) {
      if (row.entityType == "ASSET") {
        this.$confirm(
          `该操作将${row.isOpen ? "关闭" : "开启"}${row.name}内所有${
            this.$route.path == "/console" ? "照明开关" : "风机盘管/分体式空调"
          }，请确认是否执行此操作？`,
          "提示",
          {
            confirmButtonText: "执行",
            cancelButtonText: "取消",
            type: "warning",
          }
        )
          .then(() => {
            row.isOpen = !row.isOpen;
            this.$emit("changeState", row);
          })
          .catch(() => {});
      } else {
        row.isOpen = !row.isOpen;
        this.$emit("changeState", row);
      }

      return;
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.subsystemTableCom {
  width: 95%;
  height: 90%;
  margin: 20px auto 10px;
}
</style>
